/****************************************************************************************************
* howe -> page-home > web
****************************************************************************************************/

// import { waitForFinalEvent } from "./utils";


////////////////////////////////////////////////////////////////////////////////////////////////////
/// Code for snippet
// let howeIsSnippet = true;
// if(howeIsSnippet && typeof howeIsRevert !== 'undefined') {
//   howeScrollTl.revert();
//   howeTitle.revert();
//   howeCopyTl.revert();
//   howeDeviceMorph.revert();
//   howeWebOnScrollTl.revert();
//   howeWebOnTl.revert();
// }


////////////////////////////////////////////////////////////////////////////////////////////////////
/// Variables & Functions
let howeSel = '.sector.web ';


////////////////////////////////////////////////////////////////////////////////////////////////////
/// Scroll Animation
// let webBgClr1 = ['#facc22', '#f83600']; // hero bg
// let webBgClr2 = ['#015eea', '#01122b']; // web bg

let howeScrollTl; // eslint-disable-line no-unused-vars
// let howeExploreCopyTl; // eslint-disable-line no-unused-vars
let howeTitle; // eslint-disable-line no-unused-vars
let howeCopyTl; // eslint-disable-line no-unused-vars
let howeWebOnTl; // eslint-disable-line no-unused-vars
let howeDeviceMorph; // eslint-disable-line no-unused-vars
let howeWebOnScrollTl; // eslint-disable-line no-unused-vars
let howeVideo; // eslint-disable-line no-unused-vars

const howeInit = (gsapRef, splitTextRef) => {
  gsapRef.set('.sector.web .container-in', {y: '-100%', autoAlpha: 0});
  // gsapRef.set('.sector.web .web-contents, .sector.web .web-wall', {"--web-bg-clr-a": webBgClr2[0], "--web-bg-clr-b": webBgClr2[1]});
  gsapRef.set('.sector.web .web-contents-wrap', {x: '0%', y:'0%', z:'0vw', rotationZ: '0deg', rotationY: '0deg', rotationX: '0deg'});
  gsapRef.set('.sector.web .web-contents-wrap-in', {x: '0%', y:'0%', z:'0vw', rotationZ: '0deg', rotationY: '0deg', rotationX: '0deg'});
  
  gsapRef.set('.sector.web .web-wall', {x: '0%', y:'0%', z:'0vw', rotationX: '0deg', rotationY: '0deg', rotationZ: '0deg'});
  
  gsapRef.set('.sector.web .web-wall.email', {x: '6%', y:'7%', z:'-80vw',  rotationZ: '7deg', rotationY: '-71deg', rotationX: '-3deg', scale: 0.5});

  gsapRef.set('.sector.web .web-wall-back', {z:'-50vw'});
  gsapRef.set('.sector.web .web-wall-bottom', {height: '100vw', x: '0%', y:'50vw', z:'-1vw', rotationX: '0deg', rotationY: '0deg', rotationZ: '0deg'});
  gsapRef.set('.sector.web .web-wall-top', {height: '100%', x: '0%', y:'0vw', z:'0vw', rotationX: '0deg', rotationY: '0deg', rotationZ: '0deg'});
  gsapRef.set('.sector.web .web-wall-left', {x: '0%', y:'0vw', z:'-1vw', rotationX: '0deg', rotationY: '0deg', rotationZ: '0deg'});
  gsapRef.set('.sector.web .web-wall-right', {x: '0%', y:'0vw', z:'-1vw', rotationX: '0deg', rotationY: '0deg', rotationZ: '0deg' });

  gsapRef.set('.sector.web .web-tree', {clearProps: 'all'});
  gsapRef.set('.sector.web .web-tree', {opacity: 0, scale:1.5});
  gsapRef.set('.sector.web .web-tree-13', {opacity: 0, scaleX: 1.5, scaleY: -1.5});
  gsapRef.set('.sector.web .web-tree-in', {clearProps: 'all'});

  gsapRef.set('.sector.web .web-panels-wrap', {clearProps: 'all'});
  gsapRef.set('.sector.web .web-panels-wrap', {'transform-origin': '50% 50% -12vw', 'transform': 'none'});
  gsapRef.set('.sector.web .web-panel', {opacity: 0, pointerEvents: 'none'});
  gsapRef.set('.sector.web .web-panel.no1', {x: '120%', y:'-71%', z:'-60vw', rotationZ: '0deg', rotationY: '50deg', rotationX: '0deg'});
  gsapRef.set('.sector.web .web-panel.no2', {x: '-180%', y:'-10%', z:'-40vw', rotationZ: '0deg', rotationY: '-65deg', rotationX: '0deg'});
  gsapRef.set('.sector.web .web-panel.no3', {x: '200%', y:'-15%', z:'-55vw', rotationZ: '0deg', rotationY: '55deg', rotationX: '0deg'});
  gsapRef.set('.sector.web .web-panel.no4', {x: '44%', y:'-110%', z:'-65vw', rotationZ: '-4eg', rotationY: '70eg', rotationX: '-20deg'});
  gsapRef.set('.sector.web .web-panel.no5', {x: '-30%', y:'-59%', z:'-75vw', rotationZ: '-7deg', rotationY: '-90deg', rotationX: '8deg'});
  gsapRef.set('.sector.web .web-panel.no6', {x: '-200%', y:'-40%', z:'-55vw', rotationZ: '13deg', rotationY: '-60deg', rotationX: '-3deg'});
  gsapRef.set('.sector.web .web-panel-wrap-a', {'--web-panel-play-state': 'paused'});
  howeVideo = document.querySelector('.sector.web .web-panel Video');
  howeVideo.pause();

  gsapRef.set('.sector.web .web-panel-el-wrap', {y: '-5%'});
  gsapRef.set(".sector.web .tablet, .sector.web .laptop, .sector.web .desktop", { opacity: 0 });
  gsapRef.set('.sector.web .laptop5', {clearProps: 'all'});
  gsapRef.set(".sector.web .laptop5", { scale: 0, y: 0, transformOrigin: "50% 50%" });
  gsapRef.set(".sector.web .adShape3", { scale: 0, opacity: 0 });

  gsapRef.set('.sector.web .web-fireflies', {opacity: 1});
  gsapRef.set('.sector.web .web-firefly', {opacity: 0});
  gsapRef.set('.sector.web .web-firefly', {'--web-firefly-play-state': 'paused'});

  gsapRef.set('.sector.web .sector-copies', {transform: 'none'});
  gsapRef.set('.sector.web .sector-copies', {x: '-50%', y: '-50%', rotateZ: '0deg', scale: 1});
  gsapRef.set('.sector.web .sector-copy.title', {clearProps: 'all'});
  gsapRef.set('.sector.web .sector-copy.sentance', {clearProps: 'all'});
  howeTitle = new splitTextRef('.sector.web .sector-copy.title .copy', {type: 'chars,words', charsClass:'char char++'});
  gsapRef.set('.sector.web .sector-copy.title .copy .char', {transformOrigin: 'left center', autoAlpha: 0, rotationX: '70deg', y: '20%', x: '-70%'});
  gsapRef.set('.sector.web .sector-copy.sentance .copy span', { autoAlpha: 0,  y: '70%'});

  // gsapRef.set('.sector.web .explore-copy .copy', {opacity: 0, innerHTML: ''});
}


// if(howeIsSnippet) howeInit(gsap, splitTextRef);


const howeScrollMake = (gsapRef, scrollTriggerRef, smootherRef, splitTextRef) => {

  let howeScrollDur = 1;

  howeScrollTl = gsapRef.timeline({
    defaults: {ease: 'none'},
    scrollTrigger: {
      id: 'howe',
      trigger: howeSel,
      toggleActions: 'restart complete reverse reset',
      start: 'top bottom',
      end: () => `+=350%`, // 100%: over hero, 200%: web scrolling, 50%: under email
      scrub: true,
      toggleClass: 'scroll-active',
      invalidateOnRefresh: true,
      // markers: {startColor: "black", endColor: "black", fontSize: "10px", fontWeight: "bold", indent: 0}
      // onEnter: (self) =>{},
      // onLeave: (self) => {},
      // onEnterBack: (self) => {},
      // onLeaveBack: (self) => {},
      // onUpdate: (self) => console.log(`${self.vars.id}: onUpdate:`, self.progress.toFixed(3)),
      // onToggle: (self) => console.log(`${self.vars.id}: onToggle:`, self.isActive)
    }
  })
  .addLabel('t0', 0)

  .to('.sector.web .container-in', {duration: howeScrollDur*2, y: '0%'}, 't0')
  .to('.sector.web .container-in', {duration: howeScrollDur*5, y: '250%'}, `t0+=${howeScrollDur*2}`)

  .to('.sector.web .container-in', {duration: 0.05, autoAlpha: 1, ease: 'power4.out'}, `t0+=${howeScrollDur*1.95}`)
  ///// .to('.sector.web .explore-copy .copy', {duration: 0.1, autoAlpha: 1, ease: 'power4.out'}, 't0+=0.9')

  .addLabel('t1', howeScrollDur*2)
  .to('.sector.web .web-contents-wrap', {duration: howeScrollDur*4, rotationX: -10}, `t1+=${howeScrollDur}`)

  ///// .to('.sector.web .web-panels-wrap', {duration: howeScrollDur, y: '-5%', rotationY: -180}, `t1+=${howeScrollDur}`)
  ///// .to('.sector.web .web-panels-wrap', {duration: howeScrollDur, y: '0%', rotationY: -360}, `t1+=${howeScrollDur*2}`)
  .to('.sector.web .web-panels-wrap', {duration: howeScrollDur*4, y: '-5%', rotationX: 3}, `t1+=${howeScrollDur}`)

  .to('.sector.web .web-tree-09-in', {duration: howeScrollDur*4, x: '10%', ease: 'power1.out'}, `t1+=${howeScrollDur}`)
  .to('.sector.web .web-tree-01-in', {duration: howeScrollDur*4, x: '-30%', ease: 'power1.out'}, `t1+=${howeScrollDur}`)
  .to('.sector.web .web-tree-15-in', {duration: howeScrollDur*4, x: '40%', ease: 'power1.out'}, `t1+=${howeScrollDur}`)
  .to('.sector.web .web-tree-07-in', {duration: howeScrollDur*4, x: '-20%', ease: 'power1.out'}, `t1+=${howeScrollDur}`)
  .to('.sector.web .web-tree-08-in', {duration: howeScrollDur*4, x: '-20%', ease: 'power1.out'}, `t1+=${howeScrollDur}`)

  .to('.sector.web .web-tree-16-in', {duration: howeScrollDur*4, x: '60%', ease: 'power1.out'}, `t1+=${howeScrollDur}`)
  .to('.sector.web .web-tree-17-in', {duration: howeScrollDur*4, x: '-50%', ease: 'power1.out'}, `t1+=${howeScrollDur}`)

  .to('.sector.web .web-tree-10-in', {duration: howeScrollDur*4, x: '-40%', ease: 'power1.out'}, `t1+=${howeScrollDur}`)
  .to('.sector.web .web-tree-03-in', {duration: howeScrollDur*4, x: '20%', ease: 'power1.out'}, `t1+=${howeScrollDur}`)
  .to('.sector.web .web-tree-02-in', {duration: howeScrollDur*4, x: '-20%', ease: 'power1.out'}, `t1+=${howeScrollDur}`)

  .to('.sector.web .web-tree-13-in', {duration: howeScrollDur*4, x: '-25%', y: '3%', scale: 0.8, ease: 'power1.out'}, `t1+=${howeScrollDur}`)

  .to('.sector.web .web-tree-14-in', {duration: howeScrollDur*4, x: '-10%', y: '-10%', scale: 0.8, ease: 'power1.out'}, `t1+=${howeScrollDur}`)  
  ;

  // howeExploreCopyTl = gsapRef.timeline({
  //   scrollTrigger:{
  //     id: 'howeExploreCopyTl',
  //     trigger: howeSel,
  //     start: 'top 0%',
  //     end: '+=0',
  //     toggleActions: 'restart none reverse none',
  //     onEnter: (self) =>{
  //       smootherRef.paused(true);
  //     },
  //     // onLeave: (self) => {},
  //     onEnterBack: (self) => {
  //       smootherRef.paused(true)
  //     },
  //     // onLeaveBack: (self) => {},
  //   },
  //   // onStart: () => {},
  //   onComplete: () => {smootherRef.paused(false);},
  //   onReverseComplete: () => { smootherRef.paused(false);}
  // })
  // .to('.sector.web .explore-copy .copy', {duration: 1.2, scrambleText: {text: 'EXPLORE'}}, 0)

  howeCopyTl = gsapRef.timeline({
    scrollTrigger:{
      id: 'howeCopyTl',
      trigger: howeSel,
      start: 'top 0.5%',
      end: '+=0',
      toggleActions: 'restart none reverse none',
      onEnter: (self) => {
        smootherRef.paused(true);
      },
      // onLeave: (self) => {},
      onEnterBack: (self) => {
        // smootherRef.paused(true);
      },
      // onLeaveBack: (self) => {},
    },
    // onStart: () => {},
    onComplete: () => { smootherRef.paused(false); },
    // onReverseComplete: () => { smootherRef.paused(false); }
  })
  // .to('.sector.web .web-contents, .sector.web .web-wall', {duration: 0.5, "--web-bg-clr-a": webBgClr2[0], "--web-bg-clr-b": webBgClr2[1]}, 0)
  // .to('.sector.web .explore-copy .copy', {duration: 0.5, scrambleText: {text: ''}}, 0)
  .to(howeSel+' .sector-copy.title .copy .char', {duration: 0.3, autoAlpha: 1, rotationX: '0deg', y: '0%', x: '0%', stagger: 0.05, ease: 'power2.out'}, 0)
  .to(howeSel+' .sector-copy.sentance .copy span', {duration: 0.5, autoAlpha: 1, rotationX: '0deg', y: '0%', x: '0%', stagger:0.1, ease: 'back.out(2)'}, '-=0.25');

  howeDeviceMorph = gsapRef.timeline({
    repeat: -1, repeatDelay: 0.9, yoyo: false, paused: true, defaults:{duration:0.7, ease:"slow(0.5,0.5,false)"}
  })
  .add("tablet", 0)
  .set('.sector.web .web-panel-el-wrap', {y: '-5%'}, 'tablet')
  .to(".sector.web .phone", { morphSVG:(i)=>".tablet" + (i + 1) },  "tablet")
  .to(".sector.web .phone5, .sector.web .phone6", { opacity: 0, morphSVG: ".tablet5" }, "tablet")
  .to(".sector.web .adShape1", { morphSVG: ".adShape2" }, "tablet")

  .add("laptop", 1.5)
  .to('.sector.web .web-panel-el-wrap', {y: '-9%'}, 'laptop')
  .to(".sector.web .phone", { morphSVG: (i)=>".laptop" + (i + 1) }, "laptop")
  .to(".sector.web .phone3", { opacity: 0, y: -4 }, "laptop")
  // .fromTo(".sector.web .laptop5", { scale: 0, transformOrigin: "50% 50%" }, { scale: 1, opacity: 1 }, "laptop")
  .to(".sector.web .laptop5", { scale: 1, opacity: 1 }, "laptop")
  .to(".sector.web .adShape1", { morphSVG: ".adShape4" }, "laptop")
  .to(".sector.web .adShape3", { scale: 1, opacity: 1 }, "laptop")

  .add("desktop", 3)
  .to('.sector.web .web-panel-el-wrap', {y: '0%'}, 'desktop')
  .to(".sector.web .phone1", { morphSVG: ".desktop1" }, "desktop")
  .to(".sector.web .phone2", { morphSVG: ".desktop2" }, "desktop")
  .to(".sector.web .phone4", { morphSVG: ".desktop3" }, "desktop")
  .to(".sector.web .laptop5", { morphSVG: { shape: ".desktop4", shapeIndex: 0 }, y: 0.5 }, "desktop")
  .to(".sector.web .adShape1", { morphSVG: ".adShape6" }, "desktop")
  .to(".sector.web .adShape3", { morphSVG: ".adShape5" }, "desktop")

  .add("phone", 4.5)
  .to('.sector.web .web-panel-el-wrap', {y: '-5%'}, 'phone')
  .to(".sector.web .phone", { morphSVG:(i)=>".phone" + (i + 1) },  "phone")
  .to(".sector.web .phone3", { opacity: 1, y: 0 }, "phone")
  .to(".sector.web .phone5, .phone6", { opacity: 1 }, "phone")
  .to(".sector.web .laptop5", { scale: 0, transformOrigin: "50% 50%", opacity: 0, morphSVG: { shape: ".laptop5", shapeIndex: 0 }, y: 0.5 }, "phone")
  .to(".sector.web .adShape1", { morphSVG: ".adShape1" }, "phone")
  .to(".sector.web .adShape3", { scale: 0, opacity: 0, morphSVG: ".adShape3"}, "phone")

  .add("end");

  howeWebOnTl = gsapRef.timeline({
    scrollTrigger:{
      id: 'howeWebOnTl',
      trigger: howeSel,
      start: 'top -30%',
      end: '+=0',
      toggleActions: 'restart none reverse none',
      onEnter: (self) => {
        smootherRef.paused(true);
        gsapRef.set('.sector.web .web-firefly', {'--web-firefly-play-state': 'running'});
      },
      // onLeave: (self) => {},
      onEnterBack: (self) => {
        smootherRef.paused(true);
        gsapRef.set('.sector.web .web-panel-wrap-a', {'--web-panel-play-state': 'paused'});
        howeDeviceMorph.paused(true);
        howeVideo.pause();
      },
      // onLeaveBack: (self) => {},
    },
    // onStart: () => {},
    onComplete: () => {
      if(!howeWebOnScrollTl) howeWebOnScrollMake(gsapRef);
      smootherRef.paused(false);
      gsapRef.set('.sector.web .web-panel', {pointerEvents: 'auto'});
      gsapRef.set('.sector.web .web-panel-wrap-a', {'--web-panel-play-state': 'running'});
      howeDeviceMorph.paused(false);
      howeVideo.play();
    },
    onReverseComplete: () => {
      smootherRef.paused(false);
      gsapRef.set('.sector.web .web-panel', {pointerEvents: 'none'});
      gsapRef.set('.sector.web .web-firefly', {'--web-firefly-play-state': 'paused'});
    }
  })
  .addLabel('t0')
  .to('.sector.web .web-wall-top', {duration: 0.7*0.7,  transformOrigin: 'center center', height: '100vw', x: '0%', y:'-50vw', z:'0vw', rotationX: '-90deg', rotationY: '0deg', rotationZ: '0deg', ease: 'power1.out'}, 't0')
  .to('.sector.web .sector-copies', {duration: 1*0.7, x: '-136%', y: '60%', rotateZ: '60deg', scaleX: 1.5, scaleY: 1.6, ease: 'power1.out'}, 't0')
  .to('.sector.web .web-wall-bottom', {duration: 0.5*0.7, height: '100vw', x: '0%', y:'50vw', z:'0vw', rotationX: '90deg', rotationY: '0deg', rotationZ: '0deg', ease: 'power1.out'}, 't0')
  .to('.sector.web .web-wall-left', {duration: 0.8*0.7, x: '-10%', y:'0vw', z:'0vw', rotationX: '0deg', rotationY: '40deg', rotationZ: '0deg', ease: 'power2.out'}, 't0')
  .to('.sector.web .web-wall-right', {duration: 1*0.7, x: '0%', y:'0vw', z:'0vw', rotationX: '0deg', rotationY: '-70deg', rotationZ: '0deg', ease: 'none'}, 't0')

  .addLabel('t9', '-=0.1')

  .to('.sector.web .web-tree:not(.web-tree-13)', {duration: 0.7, opacity: 1, scale: 1, ease: 'power1.out', stagger:() =>Math.random()/3}, 't9+=0.3')
  .to('.sector.web .web-tree-13', {duration: 0.7, opacity: 1, scaleX: 1, scaleY: -1, ease: 'power1.out'}, 't9+=0.5')

  .to('.sector.web .web-contents-wrap-in', {duration: 0.7, x: '4%', y:'0%', z:'0vw', rotationZ: '-4deg', rotationY: '1deg', rotationX: '3deg', scale: 1, ease: 'power2.inOut'}, 't9-='+0.5)
  .to('.sector.web .web-panel', {duration: 0.2, opacity: 1}, 't9')

  /* jess test 20260410
  .to('.sector.web .web-panel.no1', {duration: 0.5, x: '-50%', y:'-71%', z:'0vw', rotationZ: '0deg', rotationY: '40deg', rotationX: '0deg', ease: 'power2.out'}, 't9+='+0.0)
  .to('.sector.web .web-panel.no2', {duration: 0.5, x: '-60%', y:'-10%', z:'10vw', rotationZ: '0deg', rotationY: '-55deg', rotationX: '0deg', ease: 'power2.out'}, 't9+='+0.1)
  .to('.sector.web .web-panel.no3', {duration: 0.5, x: '42%', y:'-10%', z:'10vw', rotationZ: '0deg', rotationY: '55deg', rotationX: '0deg', ease: 'power2.out'}, 't9+='+0.2)
  .to('.sector.web .web-panel.no4', {duration: 0.5, x: '-90%', y:'-50%', z:'-16vw', rotationZ: '16deg', rotationY: '53deg', rotationX: '-1deg', ease: 'power2.out'}, 't9+='+0.3)
  .to('.sector.web .web-panel.no5', {duration: 0.5, x: '-10%', y:'-50%', z:'-12vw', rotationZ: '-7deg', rotationY: '-60deg', rotationX: '11deg', ease: 'power2.out'}, 't9+='+0.4)
  .to('.sector.web .web-panel.no6', {duration: 0.5, x: '-100%', y:'20%', z:'-15vw', rotationZ: '13deg', rotationY: '-27deg', rotationX: '-13deg', ease: 'power2.out'}, 't9+='+0.5)
  */
  .to('.sector.web .web-panel.no1', {duration: 0.5, x: '-50%', y:'-50%', z:'-8vw', rotationZ: '-6deg', rotationY: '40deg', rotationX: '0deg', ease: 'power2.out'}, 't9+='+0.0)
  .to('.sector.web .web-panel.no2', {duration: 0.5, x: '-57%', y:'38%', z:'5vw', rotationZ: '0deg', rotationY: '-55deg', rotationX: '0deg', ease: 'power2.out'}, 't9+='+0.1)
  .to('.sector.web .web-panel.no3', {duration: 0.5, x: '42%', y:'-5%', z:'8vw', rotationZ: '0deg', rotationY: '55deg', rotationX: '0deg', ease: 'power2.out'}, 't9+='+0.2)
  .to('.sector.web .web-panel.no4', {duration: 0.5, x: '-36%', y:'-110%', z:'-15vw', rotationZ: '16deg', rotationY: '53deg', rotationX: '-1deg', ease: 'power2.out'}, 't9+='+0.3)
  .to('.sector.web .web-panel.no5', {duration: 0.5, x: '-10%', y:'-59%', z:'-8vw', rotationZ: '-7deg', rotationY: '-70deg', rotationX: '11deg', ease: 'power2.out'}, 't9+='+0.4)
  .to('.sector.web .web-panel.no6', {duration: 0.5, x: '-80%', y:'-30%', z:'-10vw', rotationZ: '13deg', rotationY: '-22deg', rotationX: '-13deg', ease: 'power2.out'}, 't9+='+0.5)

  .to('.sector.web .web-firefly', {duration: 0.5, opacity: 1}, '-=0.5')
;
}

const howeWebOnScrollMake = (gsapRef) => {
  let panelDur = 0.06; //1/15;

  howeWebOnScrollTl = gsapRef.timeline({
    defaults: {ease: 'none'},
    scrollTrigger: {
      id: 'howe',
      trigger: howeSel,
      toggleActions: 'restart complete reverse reset',
      start: 'top -50%',
      end: () => `+=150%`,
      scrub: true,
      // toggleClass: 'scroll-active',
      invalidateOnRefresh: true,
      // markers: {startColor: "black", endColor: "black", fontSize: "10px", fontWeight: "bold", indent: 0}
      // onEnter: (self) =>{},
      onLeave: (self) => { howeElsControl('pause'); },
      onEnterBack: (self) => { howeElsControl('play'); },
      // onLeaveBack: (self) => {},
      // onUpdate: (self) => console.log(`${self.vars.id}: onUpdate:`, self.progress.toFixed(3)),
      // onToggle: (self) => console.log(`${self.vars.id}: onToggle:`, self.isActive)
    }
  })
  .to('.sector.web .sector-copy.title', {duration: panelDur*14, x: '30%', ease: 'power1.out'}, 0)
  .to('.sector.web .sector-copy.sentance', {duration: panelDur*14, x: '-20%', ease: 'power1.out'}, 0)

  .to('.sector.web .web-panel.no1', {duration: panelDur*5.5, x: '-160%', y:'20%', z:'42vw', rotationZ: '-6deg', rotationY: '90deg', rotationX: '0deg', ease: 'none'},  panelDur*1.5*5)
  .to('.sector.web .web-panel.no2', {duration: panelDur*5.5, x: '10%', y:'38%', z:'50vw', rotationZ: '0deg', rotationY: '-95deg', rotationX: '0deg', ease: 'none'},  panelDur*1.5*0)
  .to('.sector.web .web-panel.no3', {duration: panelDur*5.5, x: '-98%', y:'35%', z:'63vw', rotationZ: '0deg', rotationY: '55deg', rotationX: '0deg', ease: 'none'},  panelDur*1.5*1)
  .to('.sector.web .web-panel.no4', {duration: panelDur*5.5, x: '-166%', y:'-240%', z:'35vw', rotationZ: '16deg', rotationY: '53deg', rotationX: '-1deg', ease: 'none'},  panelDur*1.5*3)
  .to('.sector.web .web-panel.no5', {duration: panelDur*5.5, x: '50%', y:'-129%', z:'42vw', rotationZ: '-7deg', rotationY: '-90deg', rotationX: '11deg', ease: 'none'},  panelDur*1.5*4)
  .to('.sector.web .web-panel.no6', {duration: panelDur*5.5, x: '130%', y:'200%', z:'25vw', rotationZ: '23deg', rotationY: '-102deg', rotationX: '-13deg', ease: 'none'}, panelDur*1.5*2)

  .addLabel ('tEmail', panelDur*1.5*4.5) // 1.5*4.5 = 6.75 - 15 = 8.25
  .to('.sector.web .web-wall.email', {duration: panelDur*4.5, x: '16%', y:'7%', z:'-20vw', rotationZ: '7deg', rotationY: '-71deg',  rotationX: '-3deg'},  'tEmail')
  .to('.sector.web .web-wall.email', {duration: panelDur*2, x: '-1%', y:'4%', z:'-10vw', rotationZ: '3deg', rotationY: '0deg',  rotationX: '3.5deg'},  'tEmail+='+panelDur*4.5)
  .to('.sector.web .web-wall.email', {duration: panelDur*1.5, x: '-4%', y:'-1.5%', z:'8vw', rotationZ: '4.5deg', rotationY: '-1deg',  rotationX: '4deg', scale: 1, ease: 'power1.out'},  'tEmail+='+panelDur*(4.5+2))

  .addLabel ('tFirefly', panelDur*14)
  .to('.sector.web .web-fireflies', {duration: panelDur, opacity: 0}, 'tFirefly')
  ;  
}

const howeScrollClear = () => {
  if(howeScrollTl) howeScrollTl.revert();
  if(howeTitle) howeTitle.revert();
  if(howeCopyTl) howeCopyTl.revert();
  if(howeDeviceMorph) howeDeviceMorph.revert();
  if(howeWebOnScrollTl) howeWebOnScrollTl.revert(); howeWebOnScrollTl = null;
  if(howeWebOnTl) howeWebOnTl.revert();
}

// if(howeIsSnippet) howeScrollMake(gsap, scrollTrigger, smoother, splitText);


////////////////////////////////////////////////////////////////////////////////////////////////////
/// Elements Animation
const howeElsControl = (opt='play') => {
  if(opt === 'play') {
    // gsapRef.set('.sector.web .web-panel-wrap-a', {'--web-panel-play-state': 'running'});
    document.querySelectorAll('.sector.web .web-panel-wrap-a').forEach(el=>el.style.setProperty('--web-panel-play-state', 'running'));
    howeDeviceMorph.paused(false);
    howeVideo.play();
    // gsapRef.set('.sector.web .web-firefly', {'--web-firefly-play-state': 'running'});
    document.querySelectorAll('.sector.web .web-firefly').forEach(el=>el.style.setProperty('--web-firefly-play-state', 'running'));

  } else {
    // gsapRef.set('.sector.web .web-panel-wrap-a', {'--web-panel-play-state': 'paused'});
    document.querySelectorAll('.sector.web .web-panel-wrap-a').forEach(el=>el.style.setProperty('--web-panel-play-state', 'paused'));
    howeDeviceMorph.paused(true);
    howeVideo.pause();
    // gsapRef.set('.sector.web .web-firefly', {'--web-firefly-play-state': 'paused'});
    document.querySelectorAll('.sector.web .web-firefly').forEach(el=>el.style.setProperty('--web-firefly-play-state', 'paused'));
  }
}


////////////////////////////////////////////////////////////////////////////////////////////////////
/// Resizing

const howeResizeStart = (gsapRef, scrollTriggerRef, smootherRef, splitTextRef) => {
  console.log("[home web] Resize: START");
}

const howeResizeDone = (gsapRef, scrollTriggerRef, smootherRef, splitTextRef) => {
  console.log("[home web] Resize: END");

  howeScrollClear();
  howeInit(gsapRef, splitTextRef);
  howeScrollMake(gsapRef, scrollTriggerRef, smootherRef, splitTextRef);
}

////////// Code for snippet
// let howeResizing = false;
// const howeResizeHandle = (gsapRef, scrollTriggerRef, smootherRef, splitTextRef) => {
//   if(!howeResizing) {
//     howeResizing = true;
//     smootherRef.paused(true);
//     scrollTriggerRef.disable();

//     howeResizeStart(gsapRef, scrollTriggerRef, smootherRef, splitTextRef);
//   }

//   waitForFinalEvent(function() {
//     howeResizing = false;
//     smootherRef.paused(false);
//     scrollTriggerRef.enable();
//     scrollTriggerRef.refresh(); // jess: After resizing done, refresh the ScrollTrigger

//     howeResizeDone(gsapRef, scrollTriggerRef, smootherRef, splitTextRef);
//   }, 1000, 'howeResize');
// }
// if(howeIsSnippet) {
//   if(typeof howeIsRevert !== 'undefined') window.removeEventListener('resize', howeResizeHandleRef);
//   window.howeResizeHandleRef = howeResizeHandle;
//   window.addEventListener('resize', howeResizeHandleRef);
// }


////////////////////////////////////////////////////////////////////////////////////////////////////
/// Control Key

// Play / Pause Elements animation
const howeControlKey = (key) => {
  if(!document.querySelector(".page-home") || !howeVideo) return;

  let opt = howeVideo.paused ? 'play' : 'pause';
  howeElsControl(opt);
  console.log(`[home: web] [key: ${key} pressed] Elements animation: ${opt}`);
};

// ////////// Code for snippet
// const howeControlKeyHandler = (e) => { if(e.key === '2') howeControlKey(e.key); }
// if(howeIsSnippet) {
//  if(typeof howeIsRevert !== 'undefined') window.removeEventListener('keydown', howeControlKeyHandlerRef);
//   window.howeControlKeyHandlerRef = howeControlKeyHandler;
//   window.addEventListener('keydown', howeControlKeyHandlerRef);
// }


////////////////////////////////////////////////////////////////////////////////////////////////////
/// Code for snippet
// if(howeIsSnippet) var howeIsRevert = true;


////////////////////////////////////////////////////////////////////////////////////////////////////
/// export
export {
  howeInit,
  howeScrollMake,
  howeScrollClear,
  howeElsControl,
  howeResizeStart,
  howeResizeDone,
  howeControlKey
}
